module.exports = __webpack_public_path__ + "static/media/a94.4c37e31c.jpg";